import { useCallback } from 'react';

import { get1 } from '~/src/base/Optic';
import { ViewProps } from '../view/types';
import { MetaRecord , RecordMetaValue , MetaText } from '../figure/Meta';
import { Piece } from '../figure/Piece';
import { defFigureMod } from '../figure/FigureMod';

import State from './Figure/State';
import * as St from './Figure/State';
import { Emitter } from './Figure/Hook';
import { setActive } from './Figure/Action';

import * as css from './Figure.module.css';


export const _wasTweaked = ( state : State ) => ( index : string ) : boolean => {
	const piece : St.Piece = get1( St.ipiece( index ) )( state );
	return piece.tweaks !== defFigureMod;
};

export const _hasTweakWith = ( state : State ) => ( needle : string ) => {
	for ( const prop in state.tweaks.Rulers )
		if ( state.tweaks.Rulers.hasOwnProperty( prop ) && prop.includes( needle ) )
			return true;
	return false;
};

export interface TabProps extends ViewProps< Piece > {
	index : number;
	active : string;
	emitter : Emitter;
	modified : boolean;
}

export const Tab = ( { value : piece , index , active , emitter , modified } : TabProps ) =>
	<div
		className={ `${ css.tab } ${ active === String( index ) ? css['tab--active'] : '' } ${ modified ? css['tab--modified'] : '' }` }
		onClick={ () => emitter( setActive( String( index ) ) ) }
	>
		{ piece.Title }
	</div>
;

export interface TabsProps extends ViewProps< State > {
	emitter : Emitter;
}

export const Tabs = ( { value , emitter } : TabsProps ) => {
	const wasTweaked : ( i : string ) => boolean = useCallback( ( index : string ) => _wasTweaked( value )( index ) , [ value ] );
	const relevantPieces : Piece[] = value.figure.Pieces.filter( ( p : Piece ) => {
		const pieceType : null | MetaRecord = p.Meta.Entries
			.find( ( [ k , _ ] : [ String , MetaRecord ] ) => k === 'type' )?.[1] ?? null;

		if ( !pieceType || !RecordMetaValue.is( pieceType.Value ) || !MetaText.is( pieceType.Value.Value ) ) return true;

		if ( pieceType.Value.Value.Text !== 'hardware' ) return true;

		return false;
	} );

	if ( relevantPieces.length <= 1 )
		return <></>;
	else
		return (
			<div className={ css.tabs }>
				{ relevantPieces.map( ( piece : Piece , index : number ) => <Tab key={ index } value={ piece } index={ index } active={ value.active } emitter={ emitter } modified={ wasTweaked( String( index ) ) } /> ) }
			</div>
		);
};
